export enum StatusArquivo {
    PENDENTE = 'Pendente',
    PROCESSANDO = 'Processando',
    FINALIZADO = 'Finalizado',
    PENDERROENTE = 'Erro'
}